import * as React from "react";

function Ai(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 25" fill="none" {...props}>
      <path
        d="M18.01 9.491l-3-3M3.5 21.001c.83.83 2.17.83 3 0l13-13c.83-.83.83-2.17 0-3-.83-.83-2.17-.83-3 0l-13 13c-.83.83-.83 2.17 0 3z"
        stroke={props.color || "#fff"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 2.94L10 2.5 9.56 4 10 5.5l-1.5-.44L7 5.5 7.44 4 7 2.5l1.5.44zm-4 6L6 8.5 5.56 10 6 11.5l-1.5-.44-1.5.44.44-1.5L3 8.5l1.5.44zm15 5l1.5-.44-.44 1.5.44 1.5-1.5-.44-1.5.44.44-1.5-.44-1.5 1.5.44z"
        stroke={props.color || "#fff"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Ai;
